import Editors from "./editors/PluginSetup.js";
import Actions from "./actions/PluginSetup.js";
export default {
  install: molten => {
    Editors.install(molten);
    Actions.install(molten);
  }
};